// Executes a function(callback) only after it has stopped
// being called for at least X(wait) milliseconds.
export default (callback, wait) => {
  let timeoutId = null;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback(...args);
    }, wait);
  };
};
